import { useState } from "react";
import SectionHeader from "@/components/feature/panel/SectionHeader";
import AiGenelDurum from "./components/AiGenelDurum";
import ModelYonetimi from "./components/ModelYonetimi";
import ApiTestMerkezi from "./components/ApiTestMerkezi";
import AiLoglar from "./components/AiLoglar";

import AssistantConversations from "./components/AssistantConversations";

const tabs = [
  {id:"konusmalar",label:"Asistan konuşmaları",icon:"ri-chat-3-line"},
  { id: "genel", label: "AI Genel Durum", icon: "ri-dashboard-line" },
  { id: "modeller", label: "Model Yönetimi", icon: "ri-settings-4-line" },
  { id: "test", label: "API Test Merkezi", icon: "ri-flask-line" },
  { id: "loglar", label: "Log & Maliyet", icon: "ri-history-line" },
];

export default function AiYonetimi() {
  const [active, setActive] = useState("genel");

  return (
    <div className="space-y-6">
      <SectionHeader
        title="Yapay Zekâ Yönetimi"
        description="NVIDIA AI modellerinin durumu, yönlendirme ayarları, test merkezi ve kullanım istatistikleri."
      />

      <div className="flex flex-wrap gap-1 rounded-full border border-background-200 bg-background-100 px-1 py-1 w-fit">
        {tabs.map((t) => (
          <button
            key={t.id}
            type="button"
            onClick={() => setActive(t.id)}
            className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
              active === t.id
                ? "bg-primary-500 text-background-50"
                : "text-foreground-600 hover:text-foreground-900"
            }`}
          >
            <i className={`${t.icon} text-base`} aria-hidden="true"></i>
            {t.label}
          </button>
        ))}
      </div>

      {active === "konusmalar" && <AssistantConversations />}
      {active === "genel" && <AiGenelDurum />}
      {active === "modeller" && <ModelYonetimi />}
      {active === "test" && <ApiTestMerkezi />}
      {active === "loglar" && <AiLoglar />}
    </div>
  );
}